import { deleteChats, deleteChatsResponse } from '../requests/delete-chats';

export default async function deleteChatsUseCase(
  chatIds: string[]
): Promise<deleteChatsResponse> {
  return deleteChats(chatIds);
}
